import axios from 'axios';
import { toast } from 'react-toastify';
import { END_POINT, getJwtToken } from '../../Redux/AdminReducer/action';

/**
 * Shared request helpers for list/table screens.
 *
 * These used to be copy-pasted `fetchData` / `deleteData` / `uploadBulk` blocks
 * inside CustomTable, Table and InventoryTable. They now live here so the auth
 * header and the toast behaviour stay identical everywhere.
 */

const authHeaders = () => ({ Authorization: getJwtToken() });

export const apiGet = async (path, config = {}) => {
  try {
    const result = await axios.get(`${END_POINT}/${path}`, {
      ...config,
      headers: { ...authHeaders(), ...(config.headers || {}) },
    });
    return result?.data;
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    console.log('Check Error', error);
    return undefined;
  }
};

export const apiDelete = async (path, itemType = 'Item', { onDone } = {}) => {
  const toastId = toast.loading(`Deleting ${itemType}, please wait...`);
  try {
    await axios.delete(`${END_POINT}/${path}`, { headers: authHeaders() });
    toast.dismiss(toastId);
    toast.success(`${itemType} Deleted!`);
    // Callers that can refresh in place pass onDone; the rest keep the old
    // full-page reload so nothing silently goes stale.
    if (onDone) onDone();
    else setTimeout(() => window.location.reload(), 1000);
    return true;
  } catch (error) {
    toast.dismiss(toastId);
    toast.error(error?.response?.data || 'Failed To Delete');
    console.log('Check Error', error);
    return false;
  }
};

export const apiPost = async (path, body, { loadingText, successText, onDone } = {}) => {
  const toastId = loadingText ? toast.loading(loadingText) : null;
  try {
    const result = await axios.post(`${END_POINT}/${path}`, body, { headers: authHeaders() });
    if (toastId) toast.dismiss(toastId);
    if (successText) toast.success(successText);
    if (onDone) onDone();
    else setTimeout(() => window.location.reload(), 1000);
    return result?.data;
  } catch (error) {
    if (toastId) toast.dismiss(toastId);
    toast.error(error?.response?.data || 'Something went wrong');
    console.log('Check Error', error);
    return undefined;
  }
};
